module.exports = __webpack_public_path__ + "media/images/products/demo/vrglasses-9d41d488cf20317036b6296f92342c2a.png";